export default __webpack_public_path__ + "static/media/technical-team-member-2.efbd80b9.jpg";